import React, { Component } from "react";
import Spinner from "react-bootstrap/Spinner";
import "./PDFViewer.scss";

class PDFViewer extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.pdfFile !== this.props.pdfFile;
  }

  render() {
    return (
      <div className="pdf-viewer">
        {this.props.pdfFile ? (
          <iframe
            className="viewer-frame"
            title="PDF File"
            src={`/pdfjs-2.6.347-dist/web/viewer.html?file=${this.props.pdfFile}#0`}
            frameBorder="0"
          />
        ) : (
          <div className="pdf-spinner progress-icon">
            <Spinner animation="border" role="status" />
          </div>
        )}
      </div>
    );
  }
}

export default PDFViewer;